import React, { Component } from 'react';
import styles from './IOSInstallBanner.module.css';

class IOSInstallBanner extends Component {
  state = {
    show: false,
    platform: null,
  };

  componentDidMount() {
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isAndroid = /Android/.test(ua);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || (navigator.standalone === true);
    const dismissed = localStorage.getItem('install-banner-dismissed');

    if (isStandalone || dismissed) return;

    if (isIOS) {
      this.setState({ show: true, platform: 'ios' });
    } else if (isAndroid) {
      this.setState({ show: true, platform: 'android' });
    }
  }

  dismiss = () => {
    localStorage.setItem('install-banner-dismissed', '1');
    this.setState({ show: false });
  };

  render() {
    if (!this.state.show) return null;

    const isIOS = this.state.platform === 'ios';

    return (
      <div className={styles.Banner}>
        <div className={styles.Content}>
          <p className={styles.Title}>Add to Home Screen</p>
          {isIOS ? (
            <p className={styles.Description}>
              Tap the <span className={styles.ShareBadge}>Share</span> button
              in Safari, then tap <strong>"Add to Home Screen"</strong> for the best experience.
            </p>
          ) : (
            <p className={styles.Description}>
              Tap the <span className={styles.ShareBadge}>⋮</span> menu in
              Chrome, then tap <strong>"Add to Home screen"</strong> for the best experience.
            </p>
          )}
        </div>
        <button onClick={this.dismiss} className={styles.DismissButton}>
          Don't show again
        </button>
      </div>
    );
  }
}

export default IOSInstallBanner;
